// Agent Command permission constants — mirrors the EXACT minLevel values
// already enforced server-side. This is not a new role vocabulary; it is
// a client-side preview of the same two numbers the API routes already
// gate on. The server re-checks on every call regardless of what this
// preview shows.
//
//   create an action request  -> api/square/agent-workspace/action-requests.ts   minLevel 20
//   approve/reject a request  -> api/square/agent-workspace/approve.ts           minLevel 80

export const AGENT_ACTION_CREATE_MIN_LEVEL = 20
export const AGENT_ACTION_DECIDE_MIN_LEVEL = 80
